import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import { connect } from "react-redux";
import { FormattedMessage, injectIntl } from "react-intl";
import * as auth from "../_redux/authRedux";
import { login } from "../_redux/authCrud";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers/AssetsHelpers";

/*
  INTL (i18n) docs:
  https://github.com/formatjs/react-intl/blob/master/docs/Components.md#formattedmessage
*/

/*
  Formik+YUP:
  https://jaredpalmer.com/formik/docs/tutorial#getfieldprops
*/

const initialValues = {
  userId: "",
  password: "",
};

function Login(props) {
  const { intl } = props;
  const [loading, setLoading] = useState(false);
  const LoginSchema = Yup.object().shape({
    userId: Yup.string()
      .min(3, "Minimum 3 symbols")
      .max(50, "Maximum 50 symbols")
      .required(
        intl.formatMessage({
          id: "AUTH.VALIDATION.REQUIRED_FIELD",
        })
      ),
    password: Yup.string()
      .min(3, "Minimum 3 symbols")
      .max(50, "Maximum 50 symbols")
      .required(
        intl.formatMessage({
          id: "AUTH.VALIDATION.REQUIRED_FIELD",
        })
      ),
  });

  const enableLoading = () => {
    setLoading(true);
  };

  const disableLoading = () => {
    setLoading(false);
  };

  const getInputClasses = (fieldname) => {
    if (formik.touched[fieldname] && formik.errors[fieldname]) {
      return "is-invalid";
    }

    if (formik.touched[fieldname] && !formik.errors[fieldname]) {
      return "is-valid";
    }

    return "";
  };

  const formik = useFormik({
    initialValues,
    validationSchema: LoginSchema,
    onSubmit: (values, { setStatus, setSubmitting }) => {
      enableLoading();
      setTimeout(() => {
        login(values.userId, values.password)
          .then(({ data: { success, authToken, msg } }) => {
            disableLoading();
            if (success) {
              props.login(authToken);
            } else {
              setStatus(
                intl.formatMessage({
                  id: msg,
                })
              );
            }
          })
          .catch(() => {
            setStatus(
              intl.formatMessage({
                id: "입력정보를 다시 확인해 주세요.",
              })
            );
          })
          .finally(() => {
            disableLoading();
            setSubmitting(false);
          });
      }, 1000);
    },
  });

  return (
    <div className="login-form" id="kt_login_signin_form">
      {/* begin::Head */}
      <div className="login-tit">
        <span className="login-logo" />
        <h3 className="font-size-h1">개인맞춤형 당뇨병 예방</h3>
      </div>
      {/* end::Head */}

      {/*begin::Form*/}
      <form
        onSubmit={formik.handleSubmit}
        className="form fv-plugins-bootstrap fv-plugins-framework"
      >
        {formik.status ? (
          <div className="mb-10 alert alert-custom alert-light-danger alert-dismissible">
            <div className="alert-text font-weight-bold">{formik.status}</div>
          </div>
        ) : (
          <div></div>
        )}

        <div className="form-group fv-plugins-icon-container">
          <input
            placeholder="ID"
            type="text"
            className={`form-control form-control-solid h-auto py-4 px-6 ${getInputClasses(
              "userId"
            )}`}
            name="userId"
            {...formik.getFieldProps("userId")}
          />
          {formik.touched.userId && formik.errors.userId ? (
            <div className="fv-plugins-message-container">
              <div className="fv-help-block">{formik.errors.userId}</div>
            </div>
          ) : null}
        </div>
        <div className="form-group fv-plugins-icon-container">
          <input
            placeholder="Password"
            type="password"
            className={`form-control form-control-solid h-auto py-4 px-6 ${getInputClasses(
              "password"
            )}`}
            name="password"
            {...formik.getFieldProps("password")}
          />
          {formik.touched.password && formik.errors.password ? (
            <div className="fv-plugins-message-container">
              <div className="fv-help-block">{formik.errors.password}</div>
            </div>
          ) : null}
        </div>
        <div className="form-group fv-plugins-icon-container form-group-btn">
          <button
            id="kt_login_signin_submit"
            type="submit"
            disabled={formik.isSubmitting}
            className={`btn color-primary font-size-16 w-100 px-9 py-4 my-3`}
          >
            <span className="font-color-white font-w-500">로그인</span>
            {loading && <span className="ml-3 spinner spinner-white"></span>}
          </button>
        </div>

        {/* 회원가입 버튼 */}
        {/* <div className="form-group d-flex flex-wrap form-group-last">
          <div className="btn-line-wrap">
            <button
              id="kt_login_signin_submit"
              type="button"
              disabled={formik.isSubmitting}
              className={`btn btn-line font-weight-bold px-9 py-4 my-3`}
            >
              <Link to="/auth/registration">회원가입</Link>
              {loading && <span className="ml-3 spinner spinner-white"></span>}
            </button>
          </div>
        </div> */}
      </form>
      {/*end::Form*/}
    </div>
  );
}

export default injectIntl(connect(null, auth.actions)(Login));
